import LocationModel from './LocationModel';
import UserModel from './UserModel';
import CounselorProfileModel from './CounselorProfileModel';
import moment from 'moment';

export default class PatientProfileModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.bio = data.bio || '';
    this.student_id_number = data.student_id_number || '';
    this.class_year = '' + (data.class_year || '');

    this.struggle_areas = (data.struggle_areas || []).map(s => new LocationModel(s));

    this.appointment_history = (data.appointment_history || []).map(history => {
        const counselor = history.counselor ? new CounselorProfileModel(history.counselor) : null;

        return {
          id: history.id || 0,
          start_time: moment(history.start_time).toDate(),
          provider_user_id: counselor ? counselor.id : null,
          provider_name: counselor ? counselor.name : 'N/A',
        };
    });

    this.city_of_residence = data.city_of_residence ? new LocationModel(data.city_of_residence) : null;

    this.student_status = data.student_status || '';
    this.student_athlete = data.student_athlete || false;
    this.international_student = data.international_student || false;
    this.live_on_campus = data.live_on_campus || false;

    this.user = data.user ? new UserModel(data.user) : null;

    this.completed_survey = data.completed_survey || false;

    this.credits_remaining = data.credits_remaining || null;
  }
}
